// extracted by mini-css-extract-plugin
export default {"buttons":"JdZtBA","horizontalSeparator":"G0PWC2","dropdownButtons":"PPrJNf","createButton":"azKvY4"};